<template>
  <div  style="position: relative;" :style="{height:needBlur?'100vh':''}" >

    <div :class="[needBlur ?  'blur':'']">

      <!-- top -->
      <div class="top">
        <div class="top-container">
          <div class="top-left">
            <van-popover
                v-if="productInfo.productId !== 94"
                style="margin-left:10px"
                placement="bottom-start"
                v-model="showPopover"
                theme="dark"
                trigger="click"
                :actions="actions"
                @select="onMenuSelect"
            >
              <template #reference>
                <van-image :src="require('@/assets/icons/menu.svg')"
                           height="32" fit="contain"/>
              </template>
            </van-popover>
          </div>
          <span class="top-title">{{ deviceLabel }}</span>
          <span class="top-right" :style="{visibility: loggedIn ?'hidden': 'hidden'}"
                @click="toLogin">{{ $t('ProductInfo.Login') }}</span>
        </div>
        <!-- <img class="top-left" src="@/assets/left.png" /> -->
        <!-- <img class="top-share" @click=;"onClickShare" src="@/assets/share.png" /> -->
      </div>

      <div v-if="cartridgeStatus === 1">

        <AD265UnicoreIndex v-if="productInfo.productId===94" :product-info="productInfo"
                           :user-data-integrity-data="userDataIntegrityData"
                           :cartridge-status="cartridgeStatus"/>
        <UnicoreIndex v-else-if="productInfo.popupType===3" :product-info="productInfo"
                      :user-data-integrity-data="userDataIntegrityData"
                      :cartridge-status="cartridgeStatus"/>
        <JzzIndex v-else-if="productInfo.popupType===9" :product-info="productInfo"
                  :user-data-integrity-data="userDataIntegrityData"
                  @refresh="loadProductInfo"
                  @onBottomChange="onBottomChange"
                  :cartridge-status="cartridgeStatus"/>
      </div>

      <div v-else-if="cartridgeStatus === 0"
           style="width:100vw;height:100vh; display: flex; align-items: center;flex-direction: column;justify-content: center">
        <van-loading/>
      </div>
      <div v-else style="margin-top:70px;">
        <DashCartridgeError :variant="variant"/>

        <div class="flex items-center justify-center w-full p-4">
          <van-button
              v-if="isSupportNFC"
              color="#ed6c10"
              style="border-radius: 8px;width:100%;"
              @click="onReadDevice">
            {{$t('ProductInfo.ReadDevice')}}
          </van-button>
        </div>


      </div>


      <NFCPopup v-model="showNfcPopup" :msg="androidPopupMsg"/>
    </div>

    <div style="position:absolute;left:0;right:0;top:100px" v-if="needShowLogin">
      <JzzLoginComponent  />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import UnicoreIndex from "@/components/UnicoreIndex.vue";
import {
  ANDROID_NFC_START, androidWriteFail, androidWriteSuccess,
  CORRECT_CARTRIDGE,
  ERROR_CARTRIDGE,
  getQueryParams, getQueryParamsBySearch, isAndroid,
  NO_CARTRIDGE
} from "@/util";
import {mapGetters, mapState} from "vuex";
import user from "@/api/user";
import AppAlert from "@/components/AppAlert.vue";
import DashCartridgeError from "@/components/DashCartridgeError.vue";
import nfcRepository from "@/repository/nfc/NFCRepository";
import NFCPopup from "@/components/NFCPopup.vue";
import ndef from '@taptrack/ndef'
import JzzIndex from "@/components/JzzIndex.vue";
import AD265UnicoreIndex from "@/components/AD265UnicoreIndex.vue";
import JzzLoginComponent from "../components/JzzLoginComponent.vue";


export default {
  name: 'index',
  components: {
    JzzLoginComponent,
    AD265UnicoreIndex, JzzIndex, NFCPopup, DashCartridgeError, AppAlert, UnicoreIndex},
  data: () => ({

    showPopover: false,

    actions: [
      // {text: "My cartridges", type: 3}
    ],

    devModel: 'prod',
    bodyWidth: 0,
    modelCode: '',
    tagId: '',
    showIconPlay: 'block',
    autoLoop: 3000,
    d: null,    //nfc设备油量电量信息
    cartridgeStatus: 0, //1是空 2是非法，0是正常
    errorCartridgeMessage: {
      title: '',
      message: ''
    },
    showCartridgeError: false,
    cartridgeId: null,

    userDataIntegrityData: {
      integrity: 0,
      weekSeconds: 0,
      nowSeconds: 0,
      yesterdaySeconds: 0,
      beforeYesterday: 0,
      nowSecondsPercentage: 0,
      yesterdaySecondsPercentage: 0,
      weekSecondsPercentage: 0,
      avgCartridgeDuration: 0,
      nowNumber: 0.0,
      weekNumber: 0.0,
      sumSecond: 0,
      sumNumber: 0.0,
      maxSeconds: 0
    },
    variant: '',


    showNfcPopup: false,
    disabledNfcButton: false,
    isInitErrorHandler: false,
    androidPopupMsg: {
      title: "Ready to Read",
      message: "Place your product in the NFC area",
      status: ANDROID_NFC_START
    },
  }),
  computed: {
    ...mapState("cartridge", {
      productInfo: (state) => state.flavorInfo
    }),
    ...mapState("cartridge", ["sessionCartridgeStatus"]),
    ...mapGetters("user", ["loggedIn"]),
    needBlur() {
      if ((!this.loggedIn && process.env.VUE_APP_CUSTOMER === 'jzz') && this.cartridgeStatus !== ERROR_CARTRIDGE && this.cartridgeStatus !== 0  ) {
        return true
      }
      return false
    },
    needShowLogin() {
      if ((!this.loggedIn && process.env.VUE_APP_CUSTOMER === 'jzz') && this.cartridgeStatus !== ERROR_CARTRIDGE && this.cartridgeStatus !== 0) {
        return true
      }
      return false
    },
    isSupportNFC() {
      return !!navigator.nfcReader
    },
    deviceLabel() {
      if (process.env.VUE_APP_CUSTOMER === "jzz") {
        if (this.productInfo.commodityCreationStory) {
          return `${this.productInfo.flavor}-${this.productInfo.commodityCreationStory}`;
        }
        return this.productInfo.flavor
      }else {
        return this.productInfo.flavor
      }
    },
  },
  beforeCreate() {

  },
  async created() {
    this.bodyWidth = window.screen.width
    await this.loadProductInfo()
    document.body.style.background = '#111111'
  },
  async mounted() {
    this.actions = [
      {text: this.$t("ProductInfo.Profile"), type: 1},
      {text: this.$t("ProductInfo.MyDevices"), type: 2},
      {text: this.$t("ProductInfo.MyCartridges"), type: 3}]
    if (process.env.VUE_APP_CUSTOMER === "jzz") {
      this.actions.push({text: this.$t("ProductInfo.Feedback"), type: 4})
    }
  },

  methods: {
    onBottomChange(type) {
      switch (type) {
        case 1:
          if (this.productInfo.isLikeProduct === 0) {
            this.productInfo.isLikeProduct = 1
            this.productInfo.numberOfProductLikes += 1
          }else {
            this.productInfo.isLikeProduct = 0
            this.productInfo.numberOfProductLikes -= 1
          }

          break
        case 2:
          if (this.productInfo.isCollectProduct === 0) {
            this.productInfo.isCollectProduct = 1
          }else {
            this.productInfo.isCollectProduct = 0
          }
          break
      }
    },
    CORRECT_CARTRIDGE() {
      return CORRECT_CARTRIDGE
    },
    toLogin() {
      this.$router.push({
        name: 'Login'
      })
    },
    onMenuSelect(e) {
      if (e.type === 4) {
        this.$router.push({
          name: "Feedback"
        })
        return
      }
      if (!this.loggedIn) {
        //go to login page when user is not loggedIn
        if (this.registered) {
          this.$router.push({
            path: '/login',
            query: {
              redirect: this.$route.fullPath
            }
          });
        } else {
          this.$router.push({
            path: process.env.VUE_APP_CUSTOMER === 'jzz' ? '/login' : '/register',
            query: {
              redirect: this.$route.fullPath
            }
          });
        }
        return
      }
      switch (e.type) {
        case 1:
          this.$router.push({
            name: "Profile"
          })
          break
        case 2:
          this.$router.push({
            name: "MyDevices"
          })
          break
        case 3:
          this.$router.push({
            name: "MyCartridges"
          })
          break
      }
    },
    setErrorVariant(status) {
      switch (status) {
        case NO_CARTRIDGE:
          this.variant = "no-cartridge";
          break;
        case ERROR_CARTRIDGE:
          this.variant = "error-cartridge";
          break;
      }
    },
    formatDataIntegrity(data, suffix) {
      return data === 0
          ? suffix === "%"
              ? `+${data}%`
              : "N/A"
          : data > 0
              ? `+${data}${suffix}`
              : `${data}${suffix}`;
    },
    convertDataIntegrity(dataIntegrity) {
      const {
        nowSeconds,
        yesterdaySeconds,
        weekSeconds,
        nowSecondsPercentage,
        yesterdaySecondsPercentage,
        weekSecondsPercentage,
        avgCartridgeDuration,
      } = dataIntegrity;
      dataIntegrity.nowSeconds = this.formatDataIntegrity(nowSeconds, "S");
      dataIntegrity.yesterdaySeconds = this.formatDataIntegrity(
          yesterdaySeconds,
          "S"
      );
      dataIntegrity.weekSeconds = this.formatDataIntegrity(weekSeconds, "S");
      dataIntegrity.nowSecondsPercentage = this.formatDataIntegrity(
          nowSecondsPercentage,
          "%"
      );
      dataIntegrity.yesterdaySecondsPercentage = this.formatDataIntegrity(
          yesterdaySecondsPercentage,
          "%"
      ); //(dataIntegrity.yesterdaySecondsPercentage > 0 ? `+${dataIntegrity.yesterdaySecondsPercentage}%` : `${dataIntegrity.yesterdaySecondsPercentage}%`)
      dataIntegrity.weekSecondsPercentage = this.formatDataIntegrity(
          weekSecondsPercentage,
          "%"
      ); // (dataIntegrity.weekSecondsPercentage > 0 ? `+${dataIntegrity.weekSecondsPercentage}%` : `${dataIntegrity.weekSecondsPercentage}%`)
      dataIntegrity.avgCartridgeDuration =
          avgCartridgeDuration <= 0 ? "- day" : `${avgCartridgeDuration} days`;

      return dataIntegrity;
    },

    async loadProductInfo(c,tagid,dd,refresh) {
      if (!refresh && this.sessionCartridgeStatus !== 0) {
        this.cartridgeStatus = this.sessionCartridgeStatus;
        this.setErrorVariant(this.cartridgeStatus);
        return;
      }
      try {
        let cartridgeIdStr = getQueryParams("c") || c || "";
        const deviceId = getQueryParams("tagid") || tagid || "";
        const deviceParams = getQueryParams("dd") || dd || "";

        const {status, cartridgeId} = await this.$store.dispatch(
            "cartridge/fetchBatteryAndLiquid",
            {
              cartridgeId: cartridgeIdStr,
              deviceId,
              deviceParams,
            }
        );

        this.setErrorVariant(status);

        if (status === CORRECT_CARTRIDGE) {
          const flavorInfo = await this.$store.dispatch(
              "cartridge/fetchFlavor",
              {
                cartridgeId,
                deviceId,
              }
          );
          this.cartridgeStatus = flavorInfo.tagId ? status : ERROR_CARTRIDGE;
        } else {
          this.cartridgeStatus = status;
        }
        this.setErrorVariant(this.cartridgeStatus);
        //load flavor success, save status to vuex store
        this.$store.commit(
            "cartridge/setSessionCartridgeStatus",
            this.cartridgeStatus
        );


        if (this.loggedIn) {
          if (process.env.VUE_APP_CUSTOMER === "jzz") {
            // const userDataIntegrityResp = await user.userDataIntegrity()
            // const data = userDataIntegrityResp.data
            // this.userDataIntegrityData = data //this.convertDataIntegrity(data)
          } else {
            const userDataIntegrityResp = await user.userDataIntegrity()
            const data = userDataIntegrityResp.data
            this.userDataIntegrityData = this.convertDataIntegrity(data)
          }

        } else {
          if (process.env.VUE_APP_CUSTOMER === "jzz") {
            this.userDataIntegrityData = {
              nowSeconds: 0,
              nowNumber: 0.0,
              weekSeconds: 0,
              weekNumber: 0.0,
              sumSecond: 0,
              sumNumber: 0.0,
              maxSeconds: 0
            }
          } else {
            this.userDataIntegrityData = this.convertDataIntegrity(this.userDataIntegrityData)
          }
        }
      } catch (e) {
        //TODO add network error view or server error view
        console.log(e)
        this.$dialog({
          message: e,
        });
      }
    },
    async loadProductInfoFromTag(cartridgeIdStr, deviceId, deviceParams) {
      try {
        const {status, cartridgeId} = await this.$store.dispatch(
            "cartridge/fetchBatteryAndLiquid",
            {
              cartridgeId: cartridgeIdStr,
              deviceId,
              deviceParams,
            }
        );

        this.setErrorVariant(status);

        if (status === CORRECT_CARTRIDGE) {
          const flavorInfo = await this.$store.dispatch(
              "cartridge/fetchFlavor",
              {
                cartridgeId,
                deviceId,
              }
          );
          this.cartridgeStatus = flavorInfo.tagId ? status : ERROR_CARTRIDGE;
        } else {
          this.cartridgeStatus = status;
        }
        this.setErrorVariant(this.cartridgeStatus);
        //load flavor success, save status to vuex store
        this.$store.commit(
            "cartridge/setSessionCartridgeStatus",
            this.cartridgeStatus
        );


        if (this.loggedIn) {
          const userDataIntegrityResp = await user.userDataIntegrity()
          const data = userDataIntegrityResp.data
          this.userDataIntegrityData = data //this.convertDataIntegrity(data)
        } else {
          this.userDataIntegrityData = {
            maxSeconds: 0,
            nowNumber: 0,
            nowSeconds: 0,
            sumNumber: 0,
            sumSecond: 0,
            weekNumber: 0,
            weekSeconds: 0,
          }//this.convertDataIntegrity(this.userDataIntegrityData)
        }
      } catch (e) {
        //TODO add network error view or server error view
        console.log(e)
        this.$dialog({
          message: e,
        });
      }
    },
    toLink(item) {
      if (item.link) {
        location.href = item.link;
      }
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return (false);
    },
    toDownloadPage() {
      this.$router.push({
        name: 'down'
      })
    },
    onClickShare() {
    },
    onClickGetCoupon() {
      if (this.productInfo != null) {
        this.$router.push({
          name: 'coupon',
          query: {
            tagId: this.tagId,
            isCoupon: this.productInfo.isCoupon,
            modelCode: this.modelCode,
            discountedPrice: this.productInfo.discountedPrice
          },
        })
      }
    },
    onClickVideoPlay() {
      let video = document.getElementById('startvideo')
      if (video) {
        video.play()
      }
      this.showIconPlay = 'none'
      this.autoLoop = 0
    },
    onChangeSwipe() {
      this.showIconPlay = 'block'
      let video = document.getElementById('startvideo')
      if (video) {
        video.pause()
      }
      this.autoLoop = 3000
    },
    onClickFindIt() {
      // this.$store.commit("setProductInfo", this.productInfo)
      // this.$store.commit("setModelCode", this.modelCode)
      // this.$router.push({
      //   name: "SubmitOrder",
      // });
      window.location.href = this.productInfo.cartUrl
    },
    handleHexStringToUInt16(hex) {
      let hexStr = hex;
      if (hexStr.length % 2 !== 0) {
        hexStr = `0${hexStr}`
      }

      let buffer = Buffer.alloc(2);
      buffer[0] = parseInt(hexStr.slice(0, 2), 16);
      buffer[1] = parseInt(hexStr.slice(2, 4), 16);
      const dataView = new DataView(buffer.buffer);
      return dataView.getUint16(0, true)
    },

    //NFC监听
    getNFCReader(isRead = true) {
      if (this.disabledNfcButton) {
        return null;
      }
      const nfcReader = navigator.nfcReader;
      if (!nfcReader) {
        this.$dialog.alert({
          message: "Current environment not support this function,Please download app to use it"
        });
        return null;
      }

      if (!this.isInitErrorHandler) {
        nfcReader.addEventListener(
            "receiveInvalidateWithError",
            this.handlerNFCError
        );
        this.isInitErrorHandler = true;
      }

      if (!this.isInitBegingEvent) {
        nfcReader.addEventListener(
            "receiveBegingActive",
            this.handleBeingActive
        );
        this.isInitBegingEvent = true;
      }

      if (isRead) {
        this.androidPopupMsg = {
          title: "Ready to Read",
          message: "Place your product in the NFC area",
          status: ANDROID_NFC_START
        };
      } else {
        this.androidPopupMsg = {
          title: "Ready to Write",
          message: "Place your product in the NFC area",
          status: ANDROID_NFC_START
        };
      }

      this.showNfcPopup = isAndroid();
      if (!this.showNfcPopup) {
        this.disabledNfcButton = true;
      }
      return nfcReader;
    },

    handlerNFCError(event) {
      if (event.error.errorCode !== 200) {
        // navigator.nfcReader.endReaderSession(false, "");
      }
      this.disabledNfcButton = false;
    },
    handleBeingActive(event) {
      // this.toastObj.clear();
    },

    async onReadDevice() {
      const nfcReader = this.getNFCReader();
      try {
        if (!isAndroid()) {

          this.disabledNfcButton = true
        }
        const session = await nfcReader.beginReaderSession(2, {operate: 2});
        await session.connect();

        const dataView = await session.readMultipleBlock(1, 0x14)
        const recordData = []
        for (let i = 0; i < dataView.byteLength; i++) {
          recordData.push(dataView.getUint8(i))
        }
        console.log(Buffer.from(recordData).toString('hex'))


        try {
          const message = ndef.Message.fromBytes(recordData)
          const parsedRecords = message.getRecords();
          const url = ndef.Utils.resolveUriRecordToString(parsedRecords[0]);
          const uri = new URL(url);

          let cartridgeIdStr = getQueryParamsBySearch(uri.search, "c");
          const deviceId = getQueryParamsBySearch(uri.search, "tagid");
          const deviceParams = getQueryParamsBySearch(uri.search, "dd");
          // // uri.split()
          this.loadProductInfoFromTag(cartridgeIdStr, deviceId, deviceParams)
        } catch (e) {
          throw "Invalid url"
        }

        if (isAndroid()) {
          this.androidPopupMsg = androidWriteSuccess(true);
        }
        navigator.nfcReader.endReaderSession(true);

      } catch (e) {
        console.log(e)
        if (isAndroid()) {
          this.$toast({
            type: "fail",
            message: e,
            duration: 2000
          });
          if (isAndroid()) {
            this.androidPopupMsg = androidWriteFail(false);
          }
        }
        navigator.nfcReader.endReaderSession(false, e);
      } finally {
        if (this.showNfcPopup) {
          this.androidPopuptimeoutId = setTimeout(() => {
            this.showNfcPopup = false;
          }, 1500);
          this.disabledNfcButton = false;
        }
      }
    },
  },

}
</script>

<style lang="less" scoped>
body {
  margin: 0 !important;
}

.blur {
  filter: blur(15px);
}
.web-view-container {

  .iframe-container {
    width: 100%;
    height: 100%;
    overflow: auto;
    position: fixed;
  }
}

.error-cartridge-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  font-size: 18px;
  padding: 20px;
  width: 80vw;

  .title {
    font-weight: bold;
    font-size: 20px;
  }

  .content {
    margin-top: 20px;
    font-weight: 500;
  }

  .confirm {
    width: 100%;
    margin-top: 20px;
    padding: 10px;
    font-weight: bold;
    border-radius: 8px;
    text-align: center;

  }
}
</style>
